<template lang="pug">
  #attention
    v-container.no-p(fluid)
      v-dialog(v-model="searchDialog" max-width="500")
        List

      v-form
        v-layout(row wrap align-end justify-space-between)
          v-flex.adjunct-label#top(xs12)
            h1.form-title2.pink-text Atención de asesorías
            v-tooltip(top close-delay=1000)
              v-icon.ml-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar los datos para este apartado,
                p.m-0 no te olvides de revisar la página 3 del procedimiento de registro.
                a(href="/static/documents/Atencion_Ax6_Registro_Procedimiento_160712.pdf" target="_blank") Ir al documento
        v-layout.py-1(row wrap justify-space-between)
          v-flex(d-flex xs2)
            v-text-field(
              :v-model="folio"
              label="Folio"
              :value="folio"
              disabled
            )
          v-flex(d-flex xs4)
            v-menu(
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              max-width="290px"
              )
              template(
                slot="activator"
              )
                v-text-field(
                  :value="dateFormatted(attentionDate)"
                  label="Fecha de atención"
                  readonly
                )
              v-date-picker(v-model="attentionDate" @input="menu1 = false" color="grey lighten-2")
            v-icon.visible(v-if="attentionDateVisible" @click="visible('attentionDate')") visibility
            v-icon.visible(v-if="!attentionDateVisible" @click="visible('attentionDate')") visibility_off
          v-flex(d-flex xs2)
            v-text-field(
              v-model="advisoryNumber"
              label="Asesoría No."
              :value="advisoryNumber"
              :disabled="relation === '' ? false : true"
            )
          v-flex(d-flex xs3)
            v-select(
              v-model="advisoryProvider"
              :items="userList"
              label="Atendió"
              autocomplete
              :value="advisoryProvider"
            )
        v-layout.py-1(row wrap align-end justify-space-between)
          v-flex.pr-2(d-flex xs2)
            v-menu(
              ref="startime"
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="40"
              :return-value.sync="startTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            )
              v-text-field(
                slot="activator"
                v-model="startTime"
                label="Hora inicio"
                readonly
              )
              v-time-picker(
                v-model="startTime"
                @change="$refs.startime.save(startTime); calculateMinutes()"
                header-color="#2f701d"
                format="24hr"
              )
                
          v-flex.pr-2(d-flex xs2)
            v-menu(
              ref="endtime"
              :close-on-content-click="false"
              v-model="menu3"
              :nudge-right="40"
              :return-value.sync="endTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px")
              v-text-field(
                slot="activator"
                v-model="endTime"
                label="Hora fin"
                readonly
              )
              v-time-picker(
                v-model="endTime"
                @change="$refs.endtime.save(endTime); calculateMinutes()"
                header-color="#2f701d"
                format="24hr"
              )
          v-flex.minutes.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="minutes"
              ref="Minutos"
              label="Minutos"
              disabled
            )
        v-layout.py-1(row wrap align-end justify-space-between)
          v-flex.pr-2(d-flex xs6)
            v-select(
              :items="hearFromOrgOpt"
              ref="¿Cómo supo del centro?"
              v-model="hearFromOrg"
              autocomplete
              label="¿Cómo supo del centro?"
            )

          v-flex.pr-2(d-flex xs5)
            v-select(
              :items="years"
              ref="Año inicial del caso"
              v-model="initialYear"
              label="Año inicial del caso"
              :value="initialYear"
            )

          v-flex.pr-2(d-flex xs5 v-if="enableSpecificHear")
            v-text-field(
              ref="¿Cuál?"
              v-model="specificHear"
              label="¿Cuál?"
            )

        v-layout.py-1.checkboxes(row wrap align-end justify-space-between)
          v-checkbox(
            v-model="related"
            label="¿Está asesoría se encuentra relacionada a otra?"
            hide-details
          )

</template>

<script>
import List from "../List/List"

export default {
  name: "Attention",
  props: {},
  components: {
    List
  },
  data() {
    return {
      folio: this.$store.state.record.folio,
      hearFromOrgOpt: [
        'Conocido(a)',
        'Dependencia estatal',
        'Dependencia municipal',
        'Evento público',
        'Familia de FUUNDEC-M',
        'Familiar de desaparecido(a)',
        'Internet',
        'Medio de comunicación',
        'Obispado',
        'Obispo de Saltillo',
        'ONG/OSC',
        'Otro',
        'Sacerdote',
        'Sin especificar',
      ],
      enablingOpts: ['Dependencia estatal', 'Dependencia municipal', 'Medio de comunicación', 'ONG/OSC', 'Otro'],
      numAdvisory: [1, 2, 2.2, 3, 4, 5, 5.2, 5.3],
      whoAttended: ['BIMB', 'DAJM', 'JEMR', 'MEAS', 'Otro'],
      years: [],
      actualYear: parseInt(new Date().getFullYear()),
      menu1: false,
      menu2: false,
      menu3: false,
      enableSpecificHear: false,
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    userList() {
      let usersMails = [];
      this.$store.state.userList.forEach((u) => {
        usersMails.push(u.name);
      });
      return usersMails;
    },
    relation() {
      return this.$store.state.record.relatedAdvisory;
    },
    attentionDate: {
      get() {
        return this.record.attention.attentionDate;
      },
      set(value) {
        this.$store.commit("updateAttentionDate", value);
      }
    },
    attentionDateVisible: {
      get() {
        return this.record.attention.attentionDateVisible;
      },
      set(value) {
        this.$store.commit("updateAttentionDateVisible", value);
      }
    },
    advisoryNumber: {
      get() {
        return this.record.attention.advisoryNumber;
      },
      set(value) {
        if (isNaN(value)) {
          this.$store.commit("updateAdvisoryNumber", '');
        } else {
          this.$store.commit("updateAdvisoryNumber", parseFloat(value));
        }
      }
    },
    advisoryProvider: {
      get() {
        return this.record.attention["advisoryProvider"];
      },
      set(value) {
        this.$store.commit("updateAdvisoryProvider", value);
      }
    },
    startTime: {
      get() {
        let storage = this.record;
        let startTimeExists = storage.attention && storage.attention.startTime;
        return startTimeExists ? this.$store.state.record.attention["startTime"] : null;
      },
      set(value) {
        this.$store.commit("updateStartTime", value);
      }
    },
    endTime: {
      get() {
        let storage = this.record;
        let endTimeExists = storage.attention && storage.attention.endTime;
        return endTimeExists ? this.$store.state.record.attention["endTime"] : null;
      },
      set(value) {
        this.$store.commit("updateEndTime", value);
      }
    },
    hearFromOrg: {
      get() {
        this.enableSpecificHear = this.enablingOpts.includes(this.record.attention.hearFromOrg) ? true : false;
        return this.record.attention.hearFromOrg;
      },
      set(value) {
        this.$store.commit("updateSpecificHear", '');
        this.$store.commit("updateHearFromOrg", value);
      }
    },
    specificHear: {
      get() {
        return this.record.attention.specificHear;
      },
      set(value) {
        this.$store.commit("updateSpecificHear", value);
      }
    },
    initialYear: {
      get() {
        return parseInt(this.record.attention.initialYear);
      },
      set(value) {
        this.$store.commit("updateInitialYear", value.toString());
      }
    },
    minutes() {
      return this.record.attention.minutes;
    },
    related: {
      get() {
        return this.record.attention.isRelated;
      },
      set(value) {
        if (!value) {
          this.$store.commit("updateAdvisoryNumber", '');
          this.$store.commit("updateRelatedAdvisory", '');
        }
        this.$store.commit("updateSearchDialogStatus", value);
        this.$store.commit("updateAttentionRelation", value);
      }
    },
    searchDialog: {
      get() {
        return this.$store.state.searchDialog;
      },
      set(value) {
        this.$store.commit("updateSearchDialogStatus", value);
      }
    }
  },
  methods: {
    dateFormatted(value) {
      const options = { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' }
      let date = new Date(value);
      date = date.toLocaleString('es-MX', options)
      return value ? date : '';
    },
    calculateMinutes() {
      if (this.$store.state.record.attention.startTime && this.$store.state.record.attention.endTime) {
        let startHours = parseInt(this.$store.state.record.attention.startTime.split(':')[0] * 60);
        let startMinutes = parseInt(this.$store.state.record.attention.startTime.split(':')[1]);
        let endHours = parseInt(this.$store.state.record.attention.endTime.split(':')[0] * 60);
        let endMinutes = parseInt(this.$store.state.record.attention.endTime.split(':')[1]);

        let startTimeSum = startHours + startMinutes;
        let endTimeSum = endHours + endMinutes;

        this.$store.commit("updateAttentionMinutes", (endTimeSum - startTimeSum).toString());
      }
    },
    visible(item) {
      switch (item) {
        case 'attentionDate':
          this.attentionDateVisible = !this.attentionDateVisible;
          break;
      }
    }
  },
  created() {
    this.$store.dispatch("getUserList");

    for (let i=1980; i <= this.actualYear; i++) {
      this.years.push(i);
    }
  }
};
</script>

<style scoped lang="scss">
.input-group.input-group--dirty.input-group--required.input-group--text-field.primary--text {
  width: 150px;
}

.upload {
  display: flex;
  align-self: center;
  cursor: pointer;
  p {
    font-size: 0.8rem !important;
  }
  &:hover {
    opacity: 0.7;
  }
}

.top-col {
  align-self: flex-start;
}

.checkbox-title p {
  font-size: 12px !important;
  color: rgba(0,0,0,.54) !important;
}

.input-group label {
  font-size: 12px !important;
}
input::placeholder {
  font-size: 12px !important;
}
.minutes {
  align-self: baseline;
}
.icon {
  display: block;
}
.adjunct-label {
  display: flex;
  align-items: baseline;
  i {
    font-size: 15px;
  }
}

.adjunct {
  p {
    color: white;
  }
  a {
    font-weight: bold;
    color: #F1BCDF !important;
  }
}
</style>
